<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div ref="userDocsTab">
    <div class="vx-col w-full">
      <div class="flex flex-wrap vs-con-loading__container items-center justify-center mt-8">
        <v-uploader @done="successUpload" button-text="Upload Files" ref="fileUpload" fileTypeExts="mp3,pdf,doc,docx,xls,xlsx,ppt,pptx,txt,rtf,png,jpg,jpeg,gif,mp4,mov,wmv" language="en" :multiple="false" file-size-limit="100MB" :preview="false"></v-uploader>
      </div>
      <div>
        <vs-table
                  ref="uploadsTable"
                  stripe
                  class="vs-con-loading__container"
                  single
                  max-items="5"
                  pagination
                  :data="uploadedFiles"
                  search>
          <template slot="thead">
            <vs-th></vs-th>
            <vs-th sort-key="url">File Name</vs-th>
            <vs-th sort-key="moduleName">Type</vs-th>
            <vs-th sort-key="moduleName">Linked Module</vs-th>
            <vs-th></vs-th>
            <vs-th></vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
              <vs-td>
                <img :src="setFileThumb(file.url)" width=30px class="product-img" />
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.url.substring(file.url.lastIndexOf('/') + 1) }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.documentTypeName ? file.documentTypeName : "None" }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium">{{ file.moduleName ? file.moduleName : "None" }}</p>
              </vs-td>
              <vs-td style="width: 50px;">
                <span class="flex" v-if="(file.documentTypeId == 4 || file.documentTypeId == 10) && !file.accepted">
                  <vs-button color="success" type="border" icon-pack="feather" icon="icon-check" size="small" @click.stop.prevent="accept(file.id)">Accept</vs-button>
                </span>
              </vs-td>
              <vs-td class="float-right">
                <vs-button v-if="file.documentTypeId != 9" color="danger" type="flat" icon-pack="feather" icon="icon-trash" @click.stop.prevent="removeDoc(file.id)"></vs-button>
                <vs-button v-if="file.documentTypeId == 9" color="success" type="flat" icon-pack="feather" icon="icon-download" @click.stop="downloadLogbook(file.id)"></vs-button>
                <!-- <vs-button v-if="file.documentTypeId == 9" color="success" class="vs-con-loading__container" @click="approveLogbook">Sign Logbook</vs-button> -->
              </vs-td>
              <vs-td class="float-right">
                <vs-button :id="`preview-logbook-btn_${indextr}`" color="success" size="small" style="padding: 10px !important;" class="vs-con-loading__container" icon-pack="feather" icon="icon-eye" @click.stop.prevent="open(file)">Preview</vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>

    <vs-popup id="feedbackprompt" title="Feedback" :active.sync="acceptPrompt">
      <div id="popup-content-area">
        <div class="vx-row mb-4" v-for="(question, index) in assessmentQuestions" :key="index">
          <div class="vx-col w-full">
            <h5><strong>{{question.text}}</strong></h5>
            <div class="vx-row mt-3" style="text-align: center;">
              <div class="vx-col w-1/2">
                <p-radio class="p-round p-fill p-smooth p-bigger" color="success" v-model="question.answer" :value="true" :name="`radio-${index}`">Yes</p-radio>
              </div>
              <div class="vx-col w-1/2">
                <p-radio class="p-round p-fill p-smooth p-bigger" color="success" v-model="question.answer" :value="false" :name="`radio-${index}`">No</p-radio>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vs-divider />
      <div class="vx-row">
        <vs-spacer></vs-spacer>
        <div class="vx-col">
          <vs-button ref="submitBtn" class="vs-con-loading__container" type="filled" color="success" @click="submitAnswers">Submit</vs-button>
        </div>
        <div class="vx-col">
          <vs-button class="vs-con-loading__container" type="filled" color="warning" @click="closePrompt">Cancel</vs-button>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      id="logbook-preview-popup"
      title="Logbook Preview"
      :active.sync="isLogbookPreviewPopupActive"
      fullscreen
    >
      <div v-if="logbookHtml" class="vx-row">
        <div class="vx-col w-full">
          <div id="html-content" v-html="logbookHtml"></div>
          <div class="vx-row mt-3">
            <vs-spacer />
            <div class="vx-col">
              <vs-button ref="approve_logbook_btn" class="vs-con-loading__container" @click="approveLogbook" color="success">Sign Logbook</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data() {
    return {
      documents: [],
      uploadedFiles: [],
      isLoading: false,
      logbookHtml: "",
      selectedDocument: {},
      isLogbookPreviewPopupActive: false,
      acceptPrompt: false,
      assessmentQuestions: [],
      answerData: {
        studentDocumentId: null,
        answers: []
      }
    }
  },
  watch: {
    isLogbookPreviewPopupActive: function (val) {
      if (!val) {
        this.logbookHtml = "";
      }
    },
    acceptPrompt: function(val) {
      if (!val) {
        this.assessmentQuestions = [];
      }
    }
  },
  methods: {
    getDocuments() {
      var self = this;
      self.showLoadingOnElement("uploadsTable", 1, "corners");
      
      var onSuccess = function(response) {
        self.documents = response.data;
        self.uploadedFiles = response.data.map((item) => {return {id: item.id, url: item.url, documentTypeId: item.documentTypeId , documentTypeName: item.documentTypeName, moduleName: item.moduleName} });

        if (self.$route.query.studentDocumentId) {
          setTimeout(() => {
            var file = self.uploadedFiles.filter(x => x.id == self.$route.query.studentDocumentId)[0];
            self.open(file);
            self.$router.replace({'query': null});
          }, 100);
        }
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      self.$ajaxGet(self, "Student/GetDocs", onSuccess, onFinally);
    },
    open(file){
      var self = this;
      if (file.url == "Logbook") {
        self.selectedDocument = self.documents.filter(x => x.id == file.id)[0];
        self.previewLogbook(self.selectedDocument.id, self.selectedDocument.studentId, self.selectedDocument.moduleId);
      } else {  
        window.open(file.url);
      }
    },
    accept(id) {
      var self = this;
      self.getAssessmentQuestions();
      self.answerData.studentDocumentId = id;
      self.acceptPrompt = true;
    },
    successUpload(data) {
      var self = this;
      var onSuccess = response => {
        self.uploadedFiles.push({
          id: response.data,
          url: data[0].url,
          documentTypeId: 1
        });
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Uploaded",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.fileUpload.$el);
        self.isLoading = false;
      };
      
      self.$ajaxGet(self, "Student/AddDoc?fileUrl=" + data[0].url, onSuccess, onFinally);
    },
    removeDoc(id) {
      var self = this;
      self.showLoadingOnElement("uploadsTable", 1, "corners");

      var onSuccess = function(response) {
        self.getDocuments();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-save'
        });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

      self.$ajaxGet(self, "Student/RemoveDoc/" + id, onSuccess, onFinally);
    },
    downloadLogbook(fileId){
      var self = this;
        self.showLoadingOnElement("uploadsTable", 1, "corners");

        var onSuccess = response =>{
          window.open(response.data, '_blank');
        }

        var onFinally = function() {
        self.$vs.loading.close(self.$refs.uploadsTable.$el);
      };

        self.$ajaxGet(self, "Logbook/GenerateLogbookPDF?logbookId=" + fileId, onSuccess, onFinally);
    },
    getAssessmentQuestions() {
      var self = this;
      self.showLoadingOnElement("userDocsTab", 1, "corners");

      var onSuccess = function(response) {
        self.assessmentQuestions = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.userDocsTab.$el);
      };

      self.$ajaxGet(self, "AssessmentQuestion/GetAllQuestions", onSuccess, onFinally);
    },
    setFileThumb(url) {
      if (url == 'Logbook') {
        return "https://forty5degreesstorage.blob.core.windows.net/assets/logbook.png";
      } else {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      }
    },
    previewLogbook(documentId, studentId, moduleId) {
      const self = this;
      self.showLoadingOnElement("userDocsTab", 1, "material");

      var onSuccess = function(response) {
        self.isLogbookPreviewPopupActive = true;
        self.logbookHtml = response.data;
      };
      var onFinally = (response) => {
        if (self.$refs.userDocsTab) {
          self.$vs.loading.close(self.$refs.userDocsTab.$el);
        }
      };

      self.$ajaxGet(self, `Logbook/GenerateLogbookPreview?userId=${studentId}&moduleId=${moduleId}`, onSuccess, onFinally);
    },
    approveLogbook() {
      const self = this;
      self.showLoadingOnElement("approve_logbook_btn", 0.45, "material");

      var onSuccess = function(response) {
        self.isLogbookPreviewPopupActive = false;
      };
      var onFinally = (response) => {
        if (self.$refs.approve_logbook_btn) {
          self.$vs.loading.close(self.$refs.approve_logbook_btn.$el);
        }
      };

      self.$ajaxGet(self, `Student/AcceptLogbook/${self.selectedDocument.id}`, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    showLoadingOnUploader(){
      var self = this;
      self.isLoading = true;
      self.$vs.loading({
        type: "material",
        container: self.$refs.fileUpload.$el,
        scale: 0.45
      });
    },
    submitAnswers() {
      var self = this;
      self.answerData.answers = self.assessmentQuestions.map(function(item) { return { assessmentQuestionId: item.id, answer: item.answer } });

      if (self.answerData.answers.filter(function(item) {return item.answer == null}).length > 0) {
        self.$vs.notify({
          title:'Information',
          color: "warning",
          text: "Please select an answer for all of the questions.",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-edit',
          time: 6000
        });
      } else {
        self.showLoadingOnElement("submitBtn", 0.45, "material");

        var onSuccess = function(response) {
          self.closePrompt();
          self.getDocuments();
          self.$vs.notify({
            title:'Information',
            color: "primary",
            text: "Feedback Submitted",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-check'
          });
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.submitBtn.$el);
        };

        self.$ajaxPost(self, "AssessmentQuestion/SubmitAnswers", self.answerData, onSuccess, onFinally);
      }
    },
    closePrompt () {
      this.$vs.loading.close(this.$refs.submitBtn.$el);
      this.acceptPrompt = false;
    }
  },
  mounted() {
    var self = this;
    self.getDocuments();
    self.$refs.fileUpload.$el.addEventListener("click", function(){
      if(!self.isLoading)
        self.showLoadingOnUploader();
      else{
        self.isLoading = false;
        self.$vs.loading.close(self.$refs.fileUpload.$el);
      }
    });
  }
}
</script>
<style lang="scss">
#logbook-preview-popup {
  * {
    color: #000000 !important;
  }
  .vs-popup {
    height: fit-content !important;
    background: #ffffff !important;
    color: #000000 !important;

    .vs-popup--content {
      overflow-x: hidden !important;
    }

    .vs-popup--header {
      background: #d8d8d8 !important;

      .vs-popup--close--icon {
        background: rgb(255, 255, 255) !important;
        color: rgb(0, 0, 0) !important;
      }
    }
  }
}

#feedbackprompt.con-vs-dialog .vs-dialog {
  max-width: 500px !important;
}
</style>